// Education planning mock data and calculations

export const educationCosts = {
  'Engineering': {
    'Government Colleges': 500000,
    'Mid Range Private Colleges': 1500000,
    'Premium Private Colleges': 4000000
  },
  'Architecture': {
    'Government Colleges': 300000,
    'Mid Range Private Colleges': 1200000,
    'Premium Private Colleges': 3500000
  },
  'MBBS': {
    'Government Colleges': 800000,
    'Mid Range Private Colleges': 3500000,
    'Premium Private Colleges': 8000000
  },
  'B.A LLB': {
    'Government Colleges': 200000,
    'Mid Range Private Colleges': 800000,
    'Premium Private Colleges': 2500000
  },
  'Pharma': {
    'Government Colleges': 400000,
    'Mid Range Private Colleges': 1000000,
    'Premium Private Colleges': 2500000
  },
  'B.Com': {
    'Government Colleges': 150000,
    'Mid Range Private Colleges': 500000,
    'Premium Private Colleges': 1200000
  },
  'BBA': {
    'Government Colleges': 200000,
    'Mid Range Private Colleges': 800000,
    'Premium Private Colleges': 2000000
  },
  'B.Des': {
    'Government Colleges': 300000,
    'Mid Range Private Colleges': 1500000,
    'Premium Private Colleges': 4000000
  },
  'BHM': {
    'Government Colleges': 250000,
    'Mid Range Private Colleges': 1000000,
    'Premium Private Colleges': 2500000
  }
};

export const mockCalculateEducationPlan = (formData) => {
  const {
    customFees,
    currentSavings,
    educationInflation,
    currentAge,
    yearsTo18,
    growthRate
  } = formData;

  // Convert strings to numbers
  const currentCost = parseFloat(customFees);
  const existingSavings = parseFloat(currentSavings) || 0;
  const educationInflationRate = parseFloat(educationInflation) / 100;
  const growthRateDecimal = growthRate / 100;
  const yearsToInvest = yearsTo18;

  // 1. Calculate future education cost using inflation
  const futureEducationCost = currentCost * Math.pow(1 + educationInflationRate, yearsToInvest);

  // 2. Calculate future value of current savings using investment growth rate
  let futureValueOfSavings = 0;
  if (existingSavings > 0) {
    futureValueOfSavings = existingSavings * Math.pow(1 + growthRateDecimal, yearsToInvest);
  }

  // 3. Calculate the shortfall (amount needed from SIP)
  const shortfallAfterSavings = Math.max(0, futureEducationCost - futureValueOfSavings);

  // 4. Calculate SIP required using PMT formula for the shortfall
  // PMT = FV * r / ((1 + r)^n - 1)
  const monthlyRate = growthRateDecimal / 12;
  const totalMonths = yearsToInvest * 12;
  
  let sipRequired;
  if (shortfallAfterSavings === 0) {
    sipRequired = 0;
  } else if (monthlyRate === 0) {
    sipRequired = shortfallAfterSavings / totalMonths;
  } else {
    sipRequired = shortfallAfterSavings * monthlyRate / (Math.pow(1 + monthlyRate, totalMonths) - 1);
  }

  // Round SIP to whole number
  const sipRequiredRounded = Math.round(sipRequired);

  // 5. Calculate total corpus generated through SIP
  let totalCorpusGenerated;
  if (sipRequiredRounded === 0) {
    totalCorpusGenerated = 0;
  } else if (monthlyRate === 0) {
    totalCorpusGenerated = sipRequiredRounded * totalMonths;
  } else {
    totalCorpusGenerated = sipRequiredRounded * (Math.pow(1 + monthlyRate, totalMonths) - 1) / monthlyRate;
  }

  return {
    currentCost: Math.round(currentCost),
    futureEducationCost: Math.round(futureEducationCost),
    futureValueOfSavings: Math.round(futureValueOfSavings),
    shortfallAfterSavings: Math.round(shortfallAfterSavings),
    sipRequired: sipRequiredRounded,
    totalCorpusGenerated: Math.round(totalCorpusGenerated),
    yearsTo18: yearsToInvest,
    growthRate: growthRate,
    currentAge: currentAge
  };
};